import { __makeTemplateObject } from "tslib";
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { font } from '@metro-ui/tokens/js';
import { visuallyHidden } from '../../utils/visuallyHidden';
export var Title = styled.div(function (_a) {
    var shouldHideTitle = _a.shouldHideTitle;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-weight: ", ";\n    ", "\n  "], ["\n    font-weight: ", ";\n    ", "\n  "])), font.weight.heavy, shouldHideTitle && visuallyHidden);
});
var templateObject_1;
//# sourceMappingURL=Title.js.map